'use client';

import { usePathname } from 'next/navigation';
import { ReactNode } from 'react';
import { AppShell, Box, RemoveScroll } from '@mantine/core';
import { useHeadroom, useWindowScroll } from '@mantine/hooks';
import { Footer } from '@/app/components/shell/footer/Footer';
import { Header } from '@/app/components/shell/navbar/Header';
import SupportDialog from '@/app/components/shell/navbar/supportDialog/SupportDialog';
import classes from './Shell.module.css';

export function Shell({ children }: { children: ReactNode }) {
  const [scroll] = useWindowScroll();
  const pinned = useHeadroom({ fixedAt: 120 });
  const pathname = usePathname();
  const transparent = pathname === '/' && scroll.y < 100;

  return (
    <AppShell
      header={{ height: scroll.y < 100 ? 64 : 62, offset: false }}
      footer={{ height: 354, offset: false }}
      layout='alt'
    >
      <SupportDialog />
      <AppShell.Header
        withBorder={false}
        className={RemoveScroll.classNames.zeroRight}
        style={{
          zIndex: 1000000,
          display: 'flex',
          flexDirection: 'column',
          transform: `translate3d(0, ${pinned ? 0 : '-110px'}, 0)`,
          transition: 'transform 400ms ease,background 300ms ease, height 300ms ease',
          background: transparent
            ? 'linear-gradient( rgba(10, 10, 25, 0.2), rgba(30, 30, 60, 0.4), rgba(30, 30, 50, 0.2) )'
            : 'linear-gradient( rgba(10, 10, 25, 0.8), rgba(0, 0, 0, 0.4), rgba(10, 10, 25, 0.6) ), url("/static/images/bg/2.webp") center center no-repeat',
          boxShadow: 'rgba(0, 0, 0, 0.07) 0 4px 12px 0, rgba(0, 0, 0, 0.05) 0 2px 4px 0s',
          alignItems: 'center',
        }}
      >
        <Header />
      </AppShell.Header>
      <AppShell.Main className={classes.main}>
        <Box className={classes.inner}>{children}</Box>
      </AppShell.Main>
      <AppShell.Footer className={classes.footer} zIndex={2} withBorder={false}>
        <Footer />
      </AppShell.Footer>
    </AppShell>
  );
}

export default Shell;
